import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async getClassificacoesGuia(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("classificacaoGuias/access/listarPorConvenioClassifAtend", dados, { timeout: 120000 });
        if(!Array.isArray(data)) { throw new Error("Lista de procedimentos/classificações inválida."); }
        return data;
    }, 
    getClassificacoesGuiaBox(context, filtros) {
        filtros.componente = "SearchBoxClassificacoesGuia";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("classificacaoGuias/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getClassificacaoGuias(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("classificacaoGuias/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    async getClassificacaoGuia(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("classificacaoGuias/access/obter", {ID_CLASSIFICA_GUIA: dados.id, componente: dados.componente});
        if(!data || !data.ID_CLASSIFICA_GUIA) { throw new Error(data && data.msg || "Não foi possível carregar a classificação de guia."); }
        return data;
    }, 
    async getClassificacaoGuiaPlanos(context, idRegistro) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("classificacaoGuias/access/listarClassificacaoGuiaPlanos", {ID_CLASSIFICA_GUIA: idRegistro});
        if(!Array.isArray(data)) { throw new Error("Não foi possível carregar os planos da classificação de guia."); }
        return data;
    },
    async getClassificacaoGuiaProdutos(context, idRegistro) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("classificacaoGuias/access/listarClassificacaoGuiaProdutos", {ID_CLASSIFICA_GUIA: idRegistro});
        if(!Array.isArray(data)) { throw new Error("Não foi possível carregar os procedimentos da classificação de guia."); }
        return data;
    }, 
    async deleteClassificacaoGuia(context, dados) {
        try {
            if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
            ApiService.setHeader();
            const { data } = await ApiService.postOnce("classificacaoGuias/access/excluir", {ID_CLASSIFICA_GUIA: dados.id, componente: dados.componente});
            if(!data || typeof data.resultado !== 'boolean') throw new Error("Resposta de exclusão inválida.");
            return data;
        } catch(error) {
            return {resultado: false, msg: "Não foi possível confirmar a exclusão. Atualize a lista antes de tentar novamente."};
        }
    }, 
    async postClassificacaoGuia(context, dados) {
        try {
            if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
            ApiService.setHeader();
            const { data } = await ApiService.postOnce("classificacaoGuias/access/salvar", dados);
            if(!data || typeof data !== 'object' || Array.isArray(data)) throw new Error("Resposta de gravação inválida.");
            return data;
        } catch(error) {
            return {resultado: false, msg: "Não foi possível confirmar a gravação. Atualize o cadastro antes de tentar novamente."};
        }
    }, 
    getClassGuiaQtdPrimeiro() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("classificacaoGuias/access/obterClassGuiaQtdPrimeiro").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
